/** URL-segment slugs: accents dropped, "&" spelled out, anything else non-alphanumeric to single hyphens. */
const slugifyBase = (value: string) =>
  value
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const slugifySegment = (value: string) => slugifyBase(value || '') || 'item';
